import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ApplyAppMdrPrices from '@/plugins/graphql/mutations/v2/apply-app-mdr-prices.gql';
import '@/assets/stylesheets/v2/_mdr-dialog.scss';
let TuckingQuestion = class TuckingQuestion extends Mixins() {
    back() {
        this.$emit('back');
    }
};
__decorate([
    Prop({ type: String, required: true })
], TuckingQuestion.prototype, "appUuid", void 0);
TuckingQuestion = __decorate([
    Component({
        data() {
            return {
                inputValue: '',
                showError: false,
                isLoading: false,
            };
        },
        computed: {
            isValid() {
                return this.inputValue.toUpperCase() === 'CONFIRM';
            },
        },
        methods: {
            validateInput() {
                const vm = this;
                vm.showError = !vm.isValid;
            },
            async onConfirm() {
                const vm = this;
                vm.isLoading = true;
                if (vm.isValid) {
                    await this.$apollo.mutate({
                        mutation: ApplyAppMdrPrices,
                        variables: {
                            input: {
                                appUuid: vm.appUuid,
                            },
                        },
                    });
                    this.$emit('setupComplete');
                }
            },
        },
    })
], TuckingQuestion);
export default TuckingQuestion;
